import React from 'react';
import { Body } from '@rexlabs/text';
import Box from '@rexlabs/box';
import { useToken } from '@rexlabs/styling';
import LoadingSpinner from '@rexlabs/loading-spinner';
export function LoadingState(_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'Data loading...' : _ref$children;
  var token = useToken();
  return /*#__PURE__*/React.createElement(Box, {
    p: token('spacing.xl'),
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    mr: token('spacing.xs'),
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    size: 18,
    strokeWidth: 3,
    colors: [token('palette.neutral.200')]
  })), typeof children === 'string' ? /*#__PURE__*/React.createElement(Body, {
    grey: true
  }, children) : children);
}
export default LoadingState;